var _defs, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _line, _circle, _line2, _circle2, _line3, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 156",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ringFace",
    x1: 120,
    y1: 20,
    x2: 190,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7dd3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38bdf8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 44c22-18 38 14 56-2s34-18 52 6",
    stroke: "#67e8f9",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 78c24 22 40-18 58 2s34 24 54-4",
    stroke: "#f43f8c",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 112c24-16 38 20 58 2s36-14 52 10",
    stroke: "#38bdf8",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156,
    cy: 80,
    rx: 30,
    ry: 56,
    stroke: "#f43f8c",
    strokeWidth: 9,
    transform: "rotate(-10 156 80)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162,
    cy: 78,
    rx: 28,
    ry: 54,
    stroke: "url(#ringFace)",
    strokeWidth: 12,
    transform: "rotate(-7 162 78)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162,
    cy: 78,
    rx: 15,
    ry: 36,
    stroke: "#0ea5e9",
    strokeWidth: 3.5,
    opacity: 0.65,
    transform: "rotate(-7 162 78)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 50,
    x2: 300,
    y2: 50,
    stroke: "#67e8f9",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 50,
    r: 9,
    fill: "#67e8f9"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 78,
    x2: 300,
    y2: 78,
    stroke: "#38bdf8",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 78,
    r: 9,
    fill: "#38bdf8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 106,
    x2: 300,
    y2: 106,
    stroke: "#f43f8c",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 314,
    cy: 106,
    r: 9,
    fill: "#f43f8c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandMark);
export default __webpack_public_path__ + "static/media/brand-mark.ff41dd3cd8e59d97ebae390985b80dd3.svg";
export { ForwardRef as ReactComponent };